// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"lr-z","imageAndVideoCount":"mr-z","imageAndVideoContainer":"nr-z","viewAllReviews":"or-z"};